export default (theme) => ({
  appointmentDetailsForm: {
    display: 'flex',
    flexDirection: 'column',
    width: '95%',
    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },
  },
  timezone: {
    width: 'calc(75% - 20px)',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginTop: 20,
    },
  },
  formHeader: {
    marginTop: 0,
    fontSize: 27,
    [theme.breakpoints.down('xl')]: {
      fontSize: 22,
    },
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  availabilityLabel: {
    marginTop: 5,
    color: theme.palette.font.main,
  },
  availabilitySelector: {
    marginTop: 30,
  },
  controlButton: {
    alignSelf: 'flex-end',
  },
  backButton: {
    margin: 25,
  },
});
